import { render, staticRenderFns } from "./ErrorsBlock.vue?vue&type=template&id=7a9b7ce5&"
import script from "./ErrorsBlock.vue?vue&type=script&lang=js&"
export * from "./ErrorsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports